import { z } from 'zod';

export const searchResultItemSchema = z.object({
    id: z.number(),
    title: z.string(),
    subtitle: z.string().optional().default(''),
    meta: z.string().optional().default(''),
    target_url: z.string().optional().default(''),
});

export const searchGroupsSchema = z.object({
    events: z.array(searchResultItemSchema).default([]),
    reservations: z.array(searchResultItemSchema).default([]),
    storage: z.array(searchResultItemSchema).default([]),
    blog: z.array(searchResultItemSchema).default([]),
    accounts: z.array(searchResultItemSchema).default([]),
});

export const searchResponseSchema = z.object({
    query: z.string().default(''),
    groups: searchGroupsSchema,
});

export type ISearchResultItem = z.infer<typeof searchResultItemSchema>;
export type ISearchGroups = z.infer<typeof searchGroupsSchema>;
export type ISearchResponse = z.infer<typeof searchResponseSchema>;
